<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 4a8 8 0 11-8 8 8 8 0 018-8m0-2a10 10 0 1010 10A10 10 0 0012 2z"/><path d="M12 9.09l.4.8.47.94 1 .15.88.12-.64.62-.76.74.19 1 .16.88-.77-.34-1-.5-.93.5-.72.41.13-.83.16-1.05-.77-.72-.67-.63 1-.17 1-.18.45-.9.42-.84m0-3.23a1 1 0 00-.89.55L9.78 9l-2.95.51a1 1 0 00-.51 1.72l2.13 2L8 16.11a1 1 0 001 1.15 1 1 0 00.48-.12l2.52-1.4 2.61 1.38a1 1 0 00.46.11 1 1 0 001-1.18l-.53-2.9 2.09-2a1 1 0 00-.56-1.7L14.17 9l-1.29-2.59a1 1 0 00-.9-.55z"/></svg>